import React, { useState, useContext } from 'react';
import CleanTechFull from '../../images/cleantech-full.png';
import { FirebaseContext } from '../../context/firebase';
import { Link, Redirect, useHistory } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import * as PROJECT_CODE from '../../constants/projectCode';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import SignInOptions from '../signInOptions/SignInOptions';
import companyLogoFull from '../../images/companyLogoFull.png';
import SignUpOptions from '../signInOptions/SignUpOptions';

export default function SignUp() {
	const history = useHistory();
	const { firebase } = useContext(FirebaseContext);

	const [formData, setFormData] = useState({
		fullName: '',
		email: '',
		telNumber: '',
		password: '',
		confirmPassword: '',
		check: false,
	});

	const { fullName, email, telNumber, password, confirmPassword, check } =
		formData;

	const [error, setError] = useState('');

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const handleSignUp = (e) => {
		e.preventDefault();

		//firebase
		if (password !== confirmPassword) {
			setError('Password do not match');
		} else if (check === false) {
			setError('You have to accept the terms and conditions');
		} else if (
			fullName === '' ||
			email === '' ||
			telNumber === '' ||
			password === '' ||
			confirmPassword === ''
		) {
			setError('Please fill in all the fields');
			setTimeout(() => {
				setError('');
			}, 4000);
		} else {
			console.log('Phone number is: ' + telNumber);
			firebase
				.auth()
				.createUserWithEmailAndPassword(email, password)
				.then((result) => {
					result.user
						.updateProfile({
							displayName: fullName,
							phoneNumber: telNumber,
						})
						.then(() => {
							var currentUserId = firebase.auth().currentUser.uid;
							var userPost = firebase.database().ref('/users/' + currentUserId);

							userPost.set({
								email: email,
								phoneNumber: telNumber,
								fullName: fullName,
								displayName: fullName,
								avatarCode: 'undefined',
								project_code: PROJECT_CODE.projectCode,
								userType: 'client',
							});
							history.push(ROUTES.HOME);
						});
				})
				.catch((error) => {
					setFormData({
						fullName: '',
						email: '',
						telNumber: '',
						password: '',
						confirmPassword: '',
						check: false,
					});
					setError(error.message);
					setTimeout(() => {
						setError('');
					}, 4000);
				});
		}
	};

	const privacyPolicy = () => {
		return (
			<small>
				I accept the <a href='https://www.kavtek.com/privacy-policy/'>Terms & Conditions</a>
			</small>
		);
	};

	return (
		<>
			<div className='signin-form'>
				<form
					className='form formSignUp'
					onSubmit={handleSignUp}
					method='POST'
					noValidate
					autoComplete='off'
				>
					<div className='image-assets'>
						<img src={companyLogoFull} alt='Company Logo' />
					</div>
					{error && <p className='form-error'>{error}</p>}
					<h2>Register</h2>
					<small>Create a new account</small>
					<div className='form-group'>
						<TextField
							type='text'
							label='Full Name'
							name='fullName'
							value={fullName}
							onChange={(e) => onChange(e)}
						/>
					</div>
					<div className='form-group'>
						<TextField
							type='email'
							label='Email Address'
							name='email'
							value={email}
							autoComplete='false'
							onChange={(e) => onChange(e)}
						/>
					</div>
					<div className='form-group'>
						<TextField
							type='tel'
							pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
							label='Phone Number (1231231234)'
							name='telNumber'
							value={telNumber}
							autoComplete='false'
							onChange={(e) => onChange(e)}
						/>
					</div>
					<div className='form-group'>
						<TextField
							type='password'
							label='Password'
							name='password'
							minLength='6'
							value={password}
							autocomplete='off'
							autocorrect='off'
							autoComplete='false'
							onChange={(e) => onChange(e)}
						/>
					</div>
					<div className='form-group'>
						<TextField
							type='password'
							autocomplete='off'
							autocorrect='off'
							label='Confirm Password'
							name='confirmPassword'
							minLength='6'
							value={confirmPassword}
							autoComplete='false'
							onChange={(e) => onChange(e)}
						/>
					</div>
					<FormControlLabel
						control={
							<Checkbox
								checked={check}
								onChange={(e) => {
									setFormData({ ...formData, check: !check });
								}}
								name='check'
								color='primary'
							/>
						}
						label={privacyPolicy()}
					/>

					<input
						type='submit'
						className='signupbtn btn btn-primary d-block mr-0 m-auto'
						value='Register'
					/>

					<div className='line-separator'>Or</div>
					<SignUpOptions
						check={formData.check}
						setError={setError}
						error={error}
					/>
					<small className='small-login-text flex-center'>
						Already have an Account? <Link to='/signin'>Login Here</Link>
					</small>
				</form>
			</div>
		</>
	);
}
